import { Table } from '@zillow/constellation';
import { VoidDisplay } from 'components/order/fees/edit/disbursements/Voiding/VoidDisplay';
import { VoidInternalTransfersButton } from 'components/order/fees/edit/disbursements/Voiding/VoidInternalTransfersButton';
import React from 'react';
import { IInternalTransferData } from 'types/order/escrow/IInternalTransferData';
import { getDateString, DateFormat } from '../../../../../ui-toolkit/utilities/getDateString';
import { currencyDisplay } from 'utilities/shared/currencyDisplay';
import { FeeInformation } from '../FeeInformationColumn';
import { useHasFeatureFlag } from 'selectors/useHasFeatureFlag';

export const InternalTransferRow: React.FC<{ item: IInternalTransferData }> = ({ item }) => {
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const sourceBase = isSpruceWithZillowEnabled ? item.sourceAccount.legalName : item.sourceAccount.spruceName;
  const sourceNickname = isZillowClosingEnabled ? item.sourceAccount.nickname : item.sourceAccount.spruceNickname;
  const sourceName = sourceNickname ? `${sourceBase} ${sourceNickname}` : sourceBase;
  const destinationBase = isSpruceWithZillowEnabled
    ? item.destinationAccount.legalName
    : item.destinationAccount.spruceName;
  const destinationNickname = isZillowClosingEnabled
    ? item.destinationAccount.nickname
    : item.destinationAccount.spruceNickname;
  const destinationName = destinationNickname ? `${destinationBase} ${destinationNickname}` : destinationBase;
  return (
    <Table.Row key={item.id}>
      <Table.Cell>
        <FeeInformation id={item.id} />
      </Table.Cell>
      <Table.Cell>{item.category}</Table.Cell>
      <Table.Cell>{item.memo}</Table.Cell>
      <Table.Cell>{currencyDisplay(item.amountCents, true)}</Table.Cell>
      <Table.Cell>{sourceName}</Table.Cell>
      <Table.Cell>{destinationName}</Table.Cell>
      <Table.Cell>{item.wellsFargoTransactionNumber}</Table.Cell>
      <Table.Cell>{item.bankReference}</Table.Cell>
      <Table.Cell>
        {item.enqueuedForDisbursementAt &&
          getDateString(DateFormat.hugeDateTime, item.enqueuedForDisbursementAt, true)}
      </Table.Cell>
      <Table.Cell>{item.disbursedAt && getDateString(DateFormat.hugeDate, item.disbursedAt)}</Table.Cell>
      <Table.Cell>{item.completedAt && getDateString(DateFormat.hugeDateTime, item.completedAt, true)}</Table.Cell>
      <Table.Cell>
        <VoidDisplay item={item} prettyVoidReason={item.voidReason} />
        <VoidInternalTransfersButton internalDisbursement={item} />
      </Table.Cell>
    </Table.Row>
  );
};
